"use client";

import Image from "next/image";
import { ChevronLeft, ChevronRight, Download } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
import React from "react";

const MouSignedImages = [
  {
    image: "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/Mou-signed-1.jpeg",
    caption: "MoU signing between Medhavi Skill University and Spaced Revision",
  },
  {
    image: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/cogito.webp",
    caption: "MoU signing between Medhavi Skill University and Cogito",
  },
  {
    image: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/Emeyc+(1).webp",
    caption: "MoU signing between Medhavi Skill University and Emeyc",
  },
  {
    image: "https://cdn.msu.edu.in/msu-reavamp/images/Placement/bolds-innovation.jpeg",
    caption: "MoU signing between Medhavi Skill University and Bolds Innovation",
  },
];

export default function MouSigned() {
  const DOWNLOAD_URL = "https://cdn.msu.edu.in/pdf/Placement-and-OJL-brochure.pdf";
  const REDIRECT_URL = "https://application.msu.edu.in/campus-programme-registration";

  const handleDownload = async () => {
    try {
      const response = await fetch(DOWNLOAD_URL);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "MSU_Placement_OJL_Brochure_2026.pdf";
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed", error);
      window.location.replace(REDIRECT_URL);
    }
  };

  return (
    <section className="page-container mx-auto pb-10 md:pb-12 px-4">
      {/* Title Section */}
      <div className="w-full text-left mb-6 md:mb-8">
        <h2
          className="font-saansBold text-black text-[20px] md:text-[25px] lg:text-[30px] xl:text-[42px] mb-2"
          style={{ fontFamily: "saans-bold" }}
        >
          Strategic MoUs & Partnerships
        </h2>
        <p className="text-sm md:text-base lg:text-lg text-black leading-relaxed w-full md:w-[80%] lg:w-[70%]">
          At Medhavi Skills University, every collaboration is a step forward in our mission to empower students with global opportunities.
        </p>
      </div>

      {/* Unified Responsive Swiper */}
      <div className="relative w-full group">
        <Swiper
          modules={[Navigation, Autoplay]}
          spaceBetween={20}
          loop={true}
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          navigation={{
            prevEl: "#mouPrevButton",
            nextEl: "#mouNextButton",
          }}
          breakpoints={{
            // Mobile (default style)
            0: {
              slidesPerView: 1.2,
              spaceBetween: 16,
            },
            // Tablets
            640: {
              slidesPerView: 2,
            },
            // Desktops
            1024: {
              slidesPerView: 3,
            },
          }}
          className="mou-swiper w-full"
        >
          {MouSignedImages.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-gray-100 rounded group-hover:shadow-md transition-shadow">
                <Image
                  src={item.image}
                  alt={item.caption}
                  fill
                  sizes="(max-width: 640px) 85vw, (max-width: 1024px) 50vw, 33vw"
                  className="object-cover transition-transform duration-500 hover:scale-105"
                />

                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />

                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <p className="text-white text-sm md:text-base leading-relaxed font-medium line-clamp-2">
                    {item.caption}
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Global Navigation Buttons (Hidden on small mobile, visible on tablet/desktop) */}
        <div className="hidden sm:flex justify-center gap-3 mt-6">
          <button
            id="mouPrevButton"
            type="button"
            className="cursor-pointer bg-white border border-gray-300 rounded-full p-2 shadow hover:bg-gray-100 transition"
          >
            <ChevronLeft className="w-5 h-5 text-gray-700" />
          </button>
          <button
            id="mouNextButton"
            type="button"
            className="cursor-pointer bg-white border border-gray-300 rounded-full p-2 shadow hover:bg-gray-100 transition"
          >
            <ChevronRight className="w-5 h-5 text-gray-700" />
          </button>
        </div>
      </div>

      {/* Download Button */}
      <div className="mt-8 md:mt-12 mb-0 md:mb-5 flex justify-center items-center w-full">
        <button
          type="button"
          onClick={handleDownload}
          className="bg-[#E09512] hover:bg-[#c97f0f] 
                     text-white font-semibold text-base md:text-lg 
                     px-6 py-3 rounded-lg shadow-md 
                     border border-gray-200 
                     hover:border-black/70
                     hover:shadow-xl 
                     transition-all duration-300 cursor-pointer
                     flex items-center justify-center gap-2"
        >
          Placement & OJL Brochure <Download size={18} />
        </button>
      </div>
    </section>
  );
}